import React from 'react';
import {
  Box,
  Button,
  ColumnLayout,
  Container,
  Header,
  SpaceBetween
} from '@cloudscape-design/components';

const FEATURE_REQUEST_URL = 'https://t.corp.amazon.com/create/templates/912582e6-cea8-478a-a57b-8f3ea1c322e0';
const BUG_REPORT_URL = 'https://t.corp.amazon.com/create/templates/42cfd9bd-6620-4e2f-a3d6-931792a4ee09';

const SubmitFeedback = () => {
  return (
    <SpaceBetween size="l">
      <Header variant="h1" description="Help us improve Chronos">
        Submit Feedback
      </Header>
      <ColumnLayout columns={2}>
        <Container header={<Header variant="h2">Feature Request</Header>}>
          <SpaceBetween size="m">
            <Box variant="p" color="text-body-secondary">
              Have an idea to improve Chronos? Submit a feature request and let us know what would make your workflow better.
            </Box>
            <Button
              variant="primary"
              href={FEATURE_REQUEST_URL}
              target="_blank"
              iconAlign="right"
              iconName="external"
            >
              Submit Feature Request
            </Button>
          </SpaceBetween>
        </Container>
        <Container header={<Header variant="h2">Bug Report</Header>}>
          <SpaceBetween size="m">
            <Box variant="p" color="text-body-secondary">
              Found something broken or not working as expected? Report it so we can fix it.
            </Box>
            <Button
              variant="primary"
              href={BUG_REPORT_URL}
              target="_blank"
              iconAlign="right"
              iconName="external"
            >
              Submit Bug Report
            </Button>
          </SpaceBetween>
        </Container>
      </ColumnLayout>
    </SpaceBetween>
  );
};

export default SubmitFeedback;
